/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import { useAiAssistanceExperimentData } from 'bundles/front-page/providers/AiAssistanceExperimentProvider';
import CoachButton from 'bundles/front-page/redesign-modules/ai-assistance/CoachButton';

import _t from 'i18n!nls/front-page';

const styles = {
  sectionContent: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--cds-spacing-200);
    justify-content: center;
    margin-top: calc(var(--cds-spacing-200) * -1);
    padding: var(--cds-spacing-400) 0;
  `,
};

const AiModuleRenderer = () => {
  const { aiAssistanceEnabled } = useAiAssistanceExperimentData();

  if (!aiAssistanceEnabled) {
    return null;
  }

  return (
    <Section>
      <div css={styles.sectionContent}>
        <Typography2 variant="subtitleSmall" component="h2">
          {_t("Looks like you're exploring a few options.")}
        </Typography2>
        <CoachButton />
      </div>
    </Section>
  );
};

export default AiModuleRenderer;
